import { EMPTY_LIST } from '../../../constants/common'
import {
  isEventKeyArrowLeft,
  isEventKeyArrowRight,
} from '../../../utils/events'

import {
  VIEW_REGIME_ARROW_STEP_NEXT,
  VIEW_REGIME_ARROW_STEP_NONE,
  VIEW_REGIME_ARROW_STEP_PREVIOUS,
} from './RentalPortalViewRegimeControl.constants'

function getFocusableOptions(container) {
  return Array.from(container.querySelectorAll('button:not([disabled])'))
}

function getArrowStep(event) {
  return isEventKeyArrowRight(event)
    ? VIEW_REGIME_ARROW_STEP_NEXT
    : isEventKeyArrowLeft(event)
      ? VIEW_REGIME_ARROW_STEP_PREVIOUS
      : VIEW_REGIME_ARROW_STEP_NONE
}

export function getRentalPortalViewRegimeNextArrowOption({ container, event }) {
  const step = getArrowStep(event)

  const options = step ? getFocusableOptions(container) : EMPTY_LIST

  return options[options.indexOf(event.currentTarget) + step]
}

export function getIsRentalPortalViewRegimeOptionInert({
  listViewType,
  option,
}) {
  return option.value === listViewType
}
